import { render } from "./BaseRequiredSelect.vue?vue&type=template&id=0e30f8e9"
import script from "./BaseRequiredSelect.vue?vue&type=script&lang=js"
export * from "./BaseRequiredSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__